import {
  ErrorComponent,
  RefineThemes,
  ThemedLayout,
  ThemedTitle,
  useNotificationProvider,
} from "@refinedev/antd";
import "@refinedev/antd/dist/reset.css";
import { Authenticated, Refine } from "@refinedev/core";
import routerProvider, {
  CatchAllNavigate,
  DocumentTitleHandler,
  UnsavedChangesNotifier,
} from "@refinedev/react-router";
import { ConfigProvider, App as AntdApp } from "antd";
import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router";
import { authProvider } from "./api/authProvider";
import { dataProvider } from "./api/dataProvider";
import { ActivityList } from "./pages/activity/list";
import { Dashboard } from "./pages/dashboard";
import { LoginPage } from "./pages/login";
import { MediaFeed } from "./pages/media-feed";
import { TrackedPostEdit } from "./pages/tracked-posts/edit";
import { TrackedPostList } from "./pages/tracked-posts/list";
import { CommentOutlined, DashboardOutlined, InstagramOutlined, ThunderboltOutlined } from "@ant-design/icons";

export const App = () => (
  <BrowserRouter>
    <ConfigProvider theme={RefineThemes.Blue}>
      <AntdApp>
        <Refine
          dataProvider={dataProvider}
          authProvider={authProvider}
          routerProvider={routerProvider}
          notificationProvider={useNotificationProvider}
          resources={[
            {
              name: "dashboard",
              list: "/",
              meta: { label: "Дашборд", icon: <DashboardOutlined /> },
            },
            {
              name: "media",
              list: "/posts",
              meta: { label: "Посты Instagram", icon: <InstagramOutlined /> },
            },
            {
              name: "tracked-posts",
              list: "/tracked-posts",
              edit: "/tracked-posts/:id",
              meta: { label: "Активные задания", icon: <ThunderboltOutlined /> },
            },
            {
              name: "processed-comments",
              list: "/activity",
              meta: { label: "Журнал комментариев", icon: <CommentOutlined /> },
            },
          ]}
          options={{
            syncWithLocation: true,
            warnWhenUnsavedChanges: true,
            disableTelemetry: true,
          }}
        >
          <Routes>
            <Route
              element={
                <Authenticated key="authenticated" fallback={<CatchAllNavigate to="/login" />}>
                  <ThemedLayout
                    Title={({ collapsed }) => (
                      <ThemedTitle collapsed={collapsed} text="Comment Bot" icon={<InstagramOutlined />} />
                    )}
                  >
                    <Outlet />
                  </ThemedLayout>
                </Authenticated>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="/posts" element={<MediaFeed />} />
              <Route path="/tracked-posts" element={<TrackedPostList />} />
              <Route path="/tracked-posts/:id" element={<TrackedPostEdit />} />
              <Route path="/activity" element={<ActivityList />} />
              <Route path="*" element={<ErrorComponent />} />
            </Route>

            <Route
              element={
                <Authenticated key="unauthenticated" fallback={<Outlet />}>
                  <Navigate to="/" replace />
                </Authenticated>
              }
            >
              <Route path="/login" element={<LoginPage />} />
            </Route>
          </Routes>

          <UnsavedChangesNotifier />
          <DocumentTitleHandler />
        </Refine>
      </AntdApp>
    </ConfigProvider>
  </BrowserRouter>
);
